import { jsx as _jsx } from "react/jsx-runtime";
const LABELS = {
    vegan: "Vegan",
    vegetarian: "Vegetarian",
    halal: "Halal",
    kosher: "Kosher",
    organic: "Organic",
    gluten_free: "Gluten-free",
};
export function DietaryChip({ code, label }) {
    const text = label ?? LABELS[code];
    return (_jsx("span", { className: "inline-flex items-center rounded-pill bg-success-soft px-2.5 py-1 text-caption font-medium text-success", children: text }));
}
